import { CommonsUsers } from './CommonsUsers/CommonsUsers'

export const Commons = () => {
  return (
    <>
      <CommonsUsers />
    </>
  )
}
